import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";
import { HandleDeleteStudent } from "../actions/teacherMutations";
import { formatServiceError } from "../Utilities/serviceErrorHelper";
import { TOAST_CONFIG } from "../Utilities/toastConfig";
import ConfirmDialog from "../components/Modal/ConfirmDialog";

export default function useDeleteStudent(onDeleted) {
  const intl = useIntl();
  const [studentToDelete, setStudentToDelete] = useState(null);
  const [promptStudentRemoval, setPromptStudentRemoval] = useState(false);
  const mutateDeleteStudent = useMutation({ mutationFn: HandleDeleteStudent });

  const promptDeleteStudent = (student) => {
    setStudentToDelete(student);
    setPromptStudentRemoval(true);
  };

  const resetDeleteStudent = () => {
    setPromptStudentRemoval(false);
    setStudentToDelete(null);
  };

  const deleteStudent = () => {
    setPromptStudentRemoval(false);
    mutateDeleteStudent.mutate(
      { studentEmail: studentToDelete.email },
      {
        onSuccess: (data) => {
          if (data && data.status > 199 && data.status < 300) {
            toast.success(
              <FormattedMessage id="StudentDeleted" />,
              TOAST_CONFIG,
            );
            onDeleted?.();
          } else {
            toast.warn(
              formatServiceError(intl, data?.data ?? data),
              TOAST_CONFIG,
            );
          }
          resetDeleteStudent();
        },
        onError: (err) => {
          toast.warn(
            formatServiceError(intl, err?.response?.data ?? err?.message),
            TOAST_CONFIG,
          );
          resetDeleteStudent();
        },
      },
    );
  };

  const deleteStudentPrompt = (
    <ConfirmDialog
      isOpen={promptStudentRemoval}
      title={intl.formatMessage({ id: "AreYouSure" })}
      message={
        <div>
          {intl.formatMessage(
            { id: "StudentWillBeDeleted" },
            { studentName: studentToDelete?.name },
          )}
        </div>
      }
      toggle={resetDeleteStudent}
      onProceed={deleteStudent}
      danger={true}
    />
  );

  return { promptDeleteStudent, deleteStudentPrompt };
}
